import { useProject } from "../../../../hooks/query";
import { AddHomeWorkRounded, AddRounded } from "@mui/icons-material";
import {
    Box,
    Button,
    ButtonGroup,
    Card,
    Divider,
    Typography,
    IconButton as JoyIconButton,
    Dropdown,
    MenuButton,
    Menu,
    MenuItem,
} from "@mui/joy";
import { PackageCheck, ChevronDown, BookX, ListTodo, Building2 } from "lucide-react";
import { useParams } from "react-router-dom";

import { Skeleton, Stack } from "@mui/joy";
import { motion, AnimatePresence } from "framer-motion";
import { Alert } from "../../../../shared";

export function SummaryCard() {
    const params = useParams();
    const id = params.id as string;

    const { useGetProjectById } = useProject();
    const getProjectByIdSvc = useGetProjectById(id);

    const projectDetails = getProjectByIdSvc.data;
    const isLoading = getProjectByIdSvc.isPending;

    if (getProjectByIdSvc.isError) {
        return <Alert errorMessage={(getProjectByIdSvc.error as any)?.message || "Failed to load project summary"} />;
    }

    return (
        <AnimatePresence mode="wait">
            {isLoading ? (
                <motion.div key="skeleton" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <Box display={"flex"} gap={1} alignItems={"center"} justifyContent={"space-between"}>
                        <Box display={"flex"} gap={1} alignItems={"center"}>
                            <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: "md" }} />
                            <Stack spacing={0.5}>
                                <Skeleton variant="text" width={60} height={12} />
                                <Skeleton variant="text" width={180} height={24} />
                            </Stack>
                        </Box>
                        <Box display={"flex"} gap={2}>
                            <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: "md" }} />
                            <Skeleton variant="rectangular" width={160} height={36} sx={{ borderRadius: "md" }} />
                        </Box>
                    </Box>
                </motion.div>
            ) : (
                <motion.div key="content" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                    <Box>
                        <Box display={"flex"} gap={1} alignItems={"center"} justifyContent={"space-between"}>
                            <Box display={"flex"} gap={1} alignItems={"center"}>
                                <Card sx={{ p: 1 }} variant="solid">
                                    <Building2 size={24} strokeWidth={1.4} absoluteStrokeWidth />
                                </Card>
                                <Box>
                                    <Typography level={"body-sm"}>Project</Typography>
                                    <Typography level={"title-lg"}>{projectDetails?.Name || "-"}</Typography>
                                </Box>
                            </Box>

                            <Box display={"flex"} gap={2} alignItems={"center"}>
                                <Button variant="outlined" color="neutral" startDecorator={<AddRounded />}>
                                    Follow
                                </Button>
                                <Dropdown>
                                    <ButtonGroup aria-label="new project button" variant="outlined" color="danger">
                                        <Button startDecorator={<PackageCheck size={18} />}>Mark as complete</Button>
                                        <MenuButton slots={{ root: JoyIconButton }}>
                                            <ChevronDown size={18} />
                                        </MenuButton>
                                    </ButtonGroup>
                                    <Menu placement="bottom-end" sx={{ width: 210 }}>
                                        <MenuItem>
                                            <BookX size={18} />
                                            Mark as cancelled
                                        </MenuItem>
                                        <MenuItem>
                                            <ListTodo size={18} />
                                            Mark as incomplete
                                        </MenuItem>
                                    </Menu>
                                </Dropdown>
                            </Box>
                        </Box>
                    </Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
